module.exports = __webpack_public_path__ + "static/media/student-app.cb376abc.jpg";